import styled from 'styled-components';

import colors from '../../styles/colors';

export const ContainerInputSearch = styled.div`
  width: 345px;
  height: 40px;
  display: flex;
  align-items: center;
  background: ${colors.white};
  border-radius: 5px;
  border: solid 1px ${colors.gray};
  padding: 10px;
  font-size: 16px;

  svg {
    margin-right: 5px;
    fill: ${colors.gray};
  }

  input {
    width: 100%;
    background: none;
    border: 0;
    &::placeholder {
      color: ${colors.gray};
    }
  }

  @media (max-width: 1400px) {
    width: 300px;
    height: 34px;
  }
`;
